/**
 * Recipient domain allowlist for opportunity (and similar) outbound email.
 *
 * Apps set `customization.allowedEmailDomains`. When omitted, Keystone stays
 * the default so on-prem does not silently open to other tenants.
 */

export const DEFAULT_ALLOWED_EMAIL_DOMAINS = ['keystoneenvironmental.ca'];

export function normalizeAllowedEmailDomains(raw?: string[] | null): string[] {
  const source = raw && raw.length > 0 ? raw : DEFAULT_ALLOWED_EMAIL_DOMAINS;
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of source) {
    const domain = String(item || '')
      .trim()
      .toLowerCase()
      .replace(/^@+/, '');
    if (!domain || seen.has(domain)) continue;
    seen.add(domain);
    out.push(domain);
  }
  return out.length > 0 ? out : [...DEFAULT_ALLOWED_EMAIL_DOMAINS];
}

export function isAllowedRecipientDomain(email: string, allowedDomains: string[]): boolean {
  const trimmed = (email || '').trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) return false;
  const domain = trimmed.slice(at + 1);
  return allowedDomains.some((allowed) => domain === allowed || domain.endsWith(`.${allowed}`));
}

export function formatAllowedDomainsHint(allowedDomains: string[]): string {
  if (allowedDomains.length === 0) {
    return formatAllowedDomainsHint(DEFAULT_ALLOWED_EMAIL_DOMAINS);
  }
  if (allowedDomains.length === 1) return `@${allowedDomains[0]}`;
  if (allowedDomains.length === 2) {
    return `@${allowedDomains[0]} or @${allowedDomains[1]}`;
  }
  const head = allowedDomains.slice(0, -1).map((d) => `@${d}`);
  return `${head.join(', ')}, or @${allowedDomains[allowedDomains.length - 1]}`;
}

export function tabCompleteDomainSuffixes(allowedDomains: string[]): string[] {
  return allowedDomains.map((d) => `@${d}`);
}
